requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
    scriptController.onStyleReady(() => {
      if (!customElements.get('cart-drawer')) {
        class CartDrawer extends ModalDialog {
          constructor() {
            super();

            this.footerUpdateFrame = null;
            this.footerUpdateTimer = null;
            this.resizeObserver = null;
            this.opening = false;
            this.skipNextCartUpdateFinish = false;

            if (window.addToCartAction === 'cart_drawer' && !window.location.pathname.includes('/cart')) {
              subscribe(PUB_SUB_EVENTS.cartUpdateFinish, (event) => {
                if (this.skipNextCartUpdateFinish) {
                  this.skipNextCartUpdateFinish = false;
                  return;
                }
                this.show(event);
              });
              window.addEventListener('cartDrawerReady', () => {
                this.skipNextCartUpdateFinish = true;
                this.show();
              });
            }

            scriptController.scripts.push('cart-drawer.js');
          }

          show() {
            if (this.opening || this.hasAttribute('open')) return;
            this.opening = true;
            super.show(arguments[0], true);

            if (Shopify.designMode) return;

            this.startFooterUpdates();
          }

          startFooterUpdates() {
            this.stopFooterUpdates();
            this.scheduleFooterUpdate();

            this.footerUpdateTimer = window.setTimeout(() => {
              this.scheduleFooterUpdate();
            }, 220);

            if (typeof ResizeObserver !== 'function') return;

            this.resizeObserver = new ResizeObserver(() => {
              this.scheduleFooterUpdate();
            });

            const footer = this.querySelector('.cart-drawer__footer');
            const itemsWrapper = this.querySelector('.cart-drawer__items');
            if (footer) this.resizeObserver.observe(footer);
            if (itemsWrapper) this.resizeObserver.observe(itemsWrapper);
          }

          scheduleFooterUpdate() {
            if (this.footerUpdateFrame !== null) return;

            this.footerUpdateFrame = requestAnimationFrame(() => {
              this.footerUpdateFrame = null;
              if (!this.isConnected) return;
              this.updateFooterState();
            });
          }

          updateFooterState() {
            const footer = this.querySelector('.cart-drawer__footer');
            const itemsWrapper = this.querySelector('.cart-drawer__items');
            if (!footer || !itemsWrapper) return;

            const items = itemsWrapper.querySelectorAll('.cart-drawer-item');
            const notesDropdown = footer.querySelector('.animated-dropdown__dropdown');
            let footerHeight = footer.offsetHeight;

            if (notesDropdown) footerHeight -= notesDropdown.offsetHeight;

            let itemsBottomLimit = itemsWrapper.offsetTop + footerHeight;
            items.forEach((element, index) => {
              if (index >= 2) return;
              itemsBottomLimit += index === 0 ? element.offsetHeight : element.offsetHeight / 2;
            });

            footer.classList.toggle('cart-drawer__footer--static', themeBase.windowHeight < itemsBottomLimit);
          }

          stopFooterUpdates() {
            if (this.footerUpdateFrame !== null) {
              cancelAnimationFrame(this.footerUpdateFrame);
              this.footerUpdateFrame = null;
            }

            if (this.footerUpdateTimer !== null) {
              window.clearTimeout(this.footerUpdateTimer);
              this.footerUpdateTimer = null;
            }

            if (this.resizeObserver) {
              this.resizeObserver.disconnect();
              this.resizeObserver = null;
            }
          }

          hide(callback) {
            this.stopFooterUpdates();
            this.opening = false;
            super.hide(callback);
          }

          disconnectedCallback() {
            this.stopFooterUpdates();
            if (super.disconnectedCallback) super.disconnectedCallback();
          }
        }

        customElements.define('cart-drawer', CartDrawer);
      }
    }, ['component-cart-drawer']);
  });
});
